


































































import Vue, { PropType } from 'vue';
import { CourseraCourse, CourseraPartner } from '~/models/coursera';
import NotifyMeButton, { SubscriptionState } from '../NotifyMeButton.vue';
import EnrollButton from './EnrollButton.vue';
import CourseDetail from './CourseDetail.vue';

type RatingStar = 'full' | 'empty';

export default Vue.extend({
    name: 'AboutSection',
    components: { NotifyMeButton, EnrollButton, CourseDetail },
    props: {
        course: {
            type: Object as PropType<CourseraCourse>,
            required: true,
        },
    },
    data() {
        return {
            notRegistered: true,
            showEnroll: true,
        };
    },
    computed: {
        stars(): string | null {
            if (!this.course.rating) return null;

            return this.course.rating.stars.toFixed(1);
        },
        starIcons(): RatingStar[] | null {
            if (!this.course.rating) return null;

            const rating = Math.round(this.course.rating.stars);
            return Array(5)
                .fill('empty')
                .map((_, i) => (i + 1 <= rating ? 'full' : 'empty'));
        },
        partners(): CourseraPartner[] {
            return this.course.partners || [];
        },
        courseUrl(): string {
            return `https://www.coursera.org/learn/${
                this.course.slug
            }/home/welcome?authMode=login&authProvider=highered&attemptSSOLogin=true`;
        },
    },
    methods: {
        handleSubscriptionStateChanged(state: SubscriptionState) {
            this.notRegistered = state === 'inactive' || state === 'removed';
        },
    },
});
